import React, { useState, useEffect } from 'react';
import Loading from '../components/Loading';
import { useHistory } from 'react-router-dom';
import config from '../appconfig/config.json';
import SubHeader from '../components/SubHeader';
import { Field, FieldWrapper, Form, FormElement } from '@progress/kendo-react-form';
import FormContainer from '../components/FormContainer';
import helper from '../factory/Helper';
import bmDateData from '../data/boardmeetingdatedata.json';
import img from '../images/BoardMeetingDate.png';
import { Button } from '@progress/kendo-react-buttons';
import { FormComboBox } from '../validation/Form-Components';
import { reqDayValidator, reqMonthValidator, reqYrValidator } from '../validation/Validators';
import CusToast from '../components/CusToast';
import service from '../services/StatusEnquiryApiService';
import CusTwoBtnDialog from '../components/CusTwoBtnDialog';

const BoardMeetingDate = (props) => {

    const confirmMsg = 'Once submitted, you will not be able to change the Board meeting date\n\n- To proceed with the current selection, please click on the “Submit” button below.\n\n- To select a new Board meeting date, please click on the “Close” button below.'
    
    let timer;
    const history = useHistory();

    const [isError,setIsError] = useState(false);
    const [errMsg, setErrMsg] = useState('');

    const [isLoading, setIsLoading] = useState(true); //default true
    const [isVerifying, setIsVerifying] = useState(false);
    const [showConfirmMsg,setShowConfirmMsg] = useState(false);


    const [response, setResponse] = useState();
    const [yearsArray,setYearsArray] = useState([]);
    const [daysInMonth,setDaysInMonth] = useState();
    const [selectedYear, setSelectedYear] = useState();
    const [selectedMonth, setSelectedMonth] = useState();
    const [selectedDate, setSelectedDate] = useState();

    const [validBRDate, setValidBRDate] = useState();

    const [isBRDateSubmitted,setIsBRDateSubmitted] = useState(false);
   
    const [initFormData, setInitFormData] = useState({
        PrefDay:'',
        PrefMonth:'',
        PrefYear:''
    })
 
    useEffect(() => {
        console.log('@BoardMeetingDate useEffect');
        window.scrollTo(0, 0);
  
        getData();
        return () => clearTimeout(timer);
    }, []);

    const handleSubmit = (dataItem) => {
  

        if(helper.isTokenExpired()) {
            props.history.push(config.route.SessionExpired);
            return;
        }

        
        if(dataItem.isValid) {
            let data = JSON.parse(JSON.stringify(dataItem.values));
           
            if(validateDate(data.PrefDay.value,data.PrefMonth.value,data.PrefYear.value)){
                console.log('valid')
       
                //do api call
               // let userSelectedBMDate =data.PrefDay.value+data.PrefMonth.value+data.PrefYear.value;
                let userSelectedBmDate = data.PrefYear.value+data.PrefMonth.value+data.PrefDay.value;
                let formatedBMDate = data.PrefDay.value+'/'+data.PrefMonth.value+'/'+data.PrefYear.value;
                checkBoardMeetingDate(response.StatusDtls.ApplicationNo,response.StatusDtls.UEN,userSelectedBmDate,formatedBMDate);
            }
        }
   
    }

    const submitBoardMeetingDate = (refNo,uen,formattedBMDate) => {
        setIsVerifying(true);
        let bParams = {
            uen:uen,
            bmdate:formattedBMDate
        }

        service.putBoardMeeting(refNo,bParams).then(res => {
            setIsVerifying(false);
            let resData = res.data;
            setIsVerifying(false);
            if (resData.isSucess) {
                goNext();
            }
            else {
                showErrMsg('Something went wrong. Please try again.')
            }
        })
        .catch(err => {
            console.log('err ',err);
            setIsVerifying(false);
            showErrMsg('Service is not available.')
        })
    }

    const checkBoardMeetingDate = (refNo, uen, bmdate, formattedBMDate) => {
        setIsVerifying(true);
        service.validateBoardMeeting(refNo,uen,bmdate).then( res => {
            setIsVerifying(false);
            let resData = res.data.model;
            if(resData.valid === 'true') {
                setValidBRDate(formattedBMDate);
                setShowConfirmMsg(true);
            } 
            else {
                setInitFormData({
                    PrefDay:null,
                    PrefMonth:null,
                    PrefYear:null
                })
                showErrMsg('Invalid board meeting date!\nNote: BR date must be on the same day or after LO generation date and within 14 days from LO generation date.')
            }
        })
        .catch( err => {
            setIsVerifying(false);
            console.log('err: ',err);
            showErrMsg('Service is not available.')
        })
    }

    const validateDate = (dd,mm,yyyy)=> {
        let isValid = true;
        let d = new Date();
        d.setHours(0);
        d.setMinutes(0);
        d.setSeconds(0);
        d.setMilliseconds(0);

        let userDay = parseInt(dd);
        let userMonth = parseInt(mm);
        let userYear = parseInt(yyyy);
        // let selectedDate = new Date(yyyy+'-'+mm+'-'+dd);
        let selectedDate = new Date(userYear,userMonth-1,userDay);
        const numOfDays = getDaysInMonth(userMonth,userYear)

        if(userDay > numOfDays){
            setInitFormData({
                PrefDay:null,
                PrefMonth:selectedMonth,
                PrefYear:selectedYear
            })
           
            showErrMsg('Invaild day!\nPlease choose day equal or lesser than '+numOfDays+'');
            isValid = false;
        }

        /*
        if(selectedDate.getTime() <= d.getTime()){ 
            setInitFormData({
                PrefDay:null,
                PrefMonth:null,
                PrefYear:null
            })
           
            showErrMsg('Please choose board meeting date earlier than today.');
        }
        */

        return isValid;
    }

    const goNext = () => {
   
        history.push(config.route.LetterOfOffer,{from: config.route.BoardMeetingDate,response:response}); 
    }
   
    const getData = () => {
        let resData = props.location.state.response? props.location.state.response:'';
        setResponse(resData);

        let yearArray = [];
        const currentMonth = new Date().getMonth();
        const currentYear = new Date().getFullYear();
        const nextYearDate = new Date(currentYear, 0, 1);
        const nextyr = nextYearDate.getFullYear()+1;

        yearArray.push({value:currentYear.toString(),label:currentYear.toString()});
        yearArray.push({value:nextyr.toString(),label:nextyr.toString()});
 
        setYearsArray(yearArray);

        setDaysInMonth(getDaysInMonth(currentMonth,currentYear));
        
 
        getBoardMeeting(resData.StatusDtls.ApplicationNo, yearArray);
    }

    const getBoardMeeting = (refNo, yearArray) => {
 
        service.getBoardMeeting(refNo).then( res => {
            setIsLoading(false);
            let resData = res.data.model;
            console.log('getBoardMeeting ',resData);
            if(res.data.isSucess) {
                //check api response value and bind in form data
               
                if(resData.day === null || resData.month === null || resData.year === null) { // not saved yet
                    setInitFormData({
                        PrefDay:'',
                        PrefMonth:'',
                        PrefYear:''
                    })
                }
                else {
                    setIsBRDateSubmitted(true);
                    setInitFormData({
                        PrefDay:helper.getObjInArray(resData.day,bmDateData.days),
                        PrefMonth:helper.getObjInArray(resData.month,bmDateData.months),
                        PrefYear:helper.getObjInArray(resData.year,yearArray)
                    })
                }
            }
        })
        .catch(err => {
            setIsLoading(false);
            console.log('err ',err);
        })
    }
    
    const getDaysInMonth = (month,year) => {
        // Here January is 1 based
        //Day 0 is the last day in the previous month
       return new Date(year, month, 0).getDate();
      // Here January is 0 based
      // return new Date(year, month+1, 0).getDate();
    };

    const dayChange = (e) => {
       // console.log('dayChange: ',e.target.value)
       setSelectedDate(e.target.value);
    }
    
    const monthChange = (e) => {
      //  console.log('monthChange: ',e.target.value)
      setSelectedMonth(e.target.value)
    }

    const yearChange = (e) => {
        setSelectedYear(e.target.value);
    }
    
    const showErrMsg = (msg) => {
        setIsError(true);
        setErrMsg(msg);
        setErrMsgTimeout()
    }

    const setErrMsgTimeout= () => {
        timer = setTimeout(() => {
            setIsError(false);
        }, config.error.msgTimeout);
    }

    const handleCloseBtnClick = (e) => {
        e.preventDefault();
        console.log('handleCloseBtnClick')
        setShowConfirmMsg(false);
    }

    const handleSubmitBtnClick = (e) => {
        e.preventDefault();
        setShowConfirmMsg(false);
        submitBoardMeetingDate(response.StatusDtls.ApplicationNo,response.StatusDtls.UEN,validBRDate);
    }

    const handleContinueBtnClick = (e) => {
        e.preventDefault();
        goNext();
    }
    
    if(isLoading) {
        return(
            <Loading />
        )
    }

    return (
        <div className="container-fluid">
            <SubHeader title={'Letter of Offer'} img={''}/> 
            <Form
                onSubmitClick={handleSubmit} 
                initialValues={initFormData} 
                key={JSON.stringify(initFormData)}
                render={(formRenderProps) =>(
                    <FormElement>
                        <FormContainer>
                            <fieldset>
                                <FieldWrapper>
                                    <div style={{ textAlign: 'center', padding: '20px' }}>
                                        {!isBRDateSubmitted?
                                        <h2 style={{ fontSize: '1.2em' }}>
                                            Board Meeting Date
                                        </h2>
                                        :
                                        <h2 style={{ fontSize: '1.2em' }}>
                                            You have successfully submitted your Board Meeting Date
                                        </h2>
                                        }
                                        <br />
                                        <img className="imgSccBMD" src={img} alt="imgScc" />
                                    </div>
                                </FieldWrapper>
                                <FieldWrapper>
                                <div className="row around-xs inputPair elementVisible">
                                    <div className="col-xs-12 col-sm-3 col-md-3 col-lg-3">
                                        <label style={{paddingTop:'10px'}} className="box text-left" id={'bmdlbl'}>{'Board Meeting Date'}</label>
                                    </div>
                                    <div className="col-xs-12 col-sm-3 col-md-3 col-lg-3">
                                        <div className='box'>
                                        <Field id={'PrefDay'} 
                                            name={'PrefDay'}
                                            component={FormComboBox}
                                            textField={'label'}
                                            data={bmDateData.days}
                                            placeholder={'Day'}
                                            onChange={dayChange}
                                            validator={reqDayValidator}
                                            disabled={isBRDateSubmitted}
                                         />
                                        </div>
                                    </div>
                                    <div className="col-xs-12 col-sm-3 col-md-3 col-lg-3">
                                        <div className='box'>
                                        <Field id={'PrefMonth'} 
                                            name={'PrefMonth'}
                                            component={FormComboBox}
                                            textField={'label'}
                                            data={bmDateData.months}
                                            placeholder={'Month'}
                                            onChange={monthChange}
                                            validator={reqMonthValidator}
                                            disabled={isBRDateSubmitted}
                                         />
                                        </div>
                                    </div>
                                    <div className="col-xs-12 col-sm-3 col-md-3 col-lg-3">
                                        <div className='box'>
                                        <Field id={'PrefYear'} 
                                            name={'PrefYear'}
                                            component={FormComboBox}
                                            textField={'label'}
                                            data={yearsArray}
                                            value = {selectedYear}
                                            placeholder={'Year'}
                                            onChange = {yearChange}
                                            validator={reqYrValidator}
                                            disabled={isBRDateSubmitted}
                                         />
                                        </div>
                                    </div>
                                </div>
                               
                                <div className="row around-xs inputPair elementVisible">
                                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                        <div style={{textAlign:'center',fontSize:'12px',color:'grey'}}>
                                        {'Note: BR date must be on the same day or after LO generation date and within 14 days from LO generation date.'}
                                        </div>
                                    </div>
                                </div>
                                <br/>
                                <div className="row around-xs inputPair elementVisible">
                                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                    <div style={{textAlign:'center'}}>
                                     <label style={{width:'70%'}} className="box" id={'textDesp'}>{'I/We confirm that approval has been given by the directors/partners in the board meeting for accepting the Letter of Offer'}</label>
                                    </div>
                                </div>
                                </div>

                                <div style={{paddingTop:'20px',paddingBottom:'20px'}}>
                                    <div className="row around-xs inputPair elementVisible">
                                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                            <div style={{textAlign:'center'}}>
                                                {!isBRDateSubmitted?
                                                <Button style={{width:'8em'}} type={'submit'} className="k-button btn btn-success" disabled={!formRenderProps.valid}>{config.btnName.Submit}</Button>      
                                                :
                                                <Button style={{width:'8em'}} type={'button'} className="k-button btn btn-success" onClick={handleContinueBtnClick}>{'Continue'}</Button>                  
                                                }
                                            </div>
                                         </div>
                                    </div>                            
                                </div>
                                </FieldWrapper>
                            </fieldset>
                            <CusTwoBtnDialog show={showConfirmMsg} setShow={setShowConfirmMsg} 
                                label={[
                                <div className='row' key={1}>
                                    Once submitted, you will not be able to change the Board meeting date
                                </div>,
                                <div className='row' style={{width:'100%'}} key={2}>
                                    <div style={{width:'5%',float:'left'}}>
                                        <span>-</span>    
                                    </div>
                                    <div style={{width:'95%',float:'left'}}>
                                        <span>To proceed with the current selection, please click on the “Submit” button below.</span> 
                                    </div>
                                </div>,
                                <div className='row' style={{width:'100%'}} key={3}>
                                    <div style={{width:'5%',float:'left'}}>
                                        <span>-</span>    
                                    </div>
                                    <div style={{width:'95%',float:'left'}}>
                                        <span>To select a new Board meeting date, please click on the “Close” button below.</span> 
                                    </div>
                                </div>,
                                ]}
                                style={{textAlign: "left", whiteSpace: "pre-line"}}
                                leftBtnName={'Close'} leftBtnClick={handleCloseBtnClick}
                                rightBtnName={'Submit'} rightBtnClick={handleSubmitBtnClick} />
                        </FormContainer>
                        <br/><br/>
                        <CusToast className="popUpBox" trigger={isError} setTrigger={setIsError} label={errMsg} timer={timer}  /> 
                        {isVerifying && <Loading />}
                    </FormElement>
                )} />
        </div>
    )
}

export default BoardMeetingDate;